import { StockAlert } from '../models'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomHeaderText,
  CustomProjectColumn,
  StockAlertEmailListColumn,
  StockAlertActionsColumn,
  FormLabels
} from 'src/components'
import { Typography } from 'antd'

const stockAlertListColumns: ColumnsType<StockAlert> = [
  {
    title: () => <CustomHeaderText text='Offers.Project' />,
    responsive: ['sm'],
    dataIndex: 'project',
    sorter: (a: StockAlert, b: StockAlert) => {
      return a.project.name.length - b.project.name.length
    },
    render: (_, stock) => {
      const project = stock.project
      return <CustomProjectColumn imageSource={project.main_image} name={project.name} />
    }
  },
  {
    title: () => <CustomHeaderText text='StockAlert.Threshold' />,
    responsive: ['sm'],
    dataIndex: 'threshold',
    sorter: (a: StockAlert, b: StockAlert) => {
      return a.threshold - b.threshold
    },
    render: (_, stock) => {
      return (
        <Typography.Title level={5}>
          {stock.threshold} %
        </Typography.Title>
      )
    }
  },
  {
    title: () => <CustomHeaderText text='StockAlert.Emails' />,
    responsive: ['sm'],
    dataIndex: 'project',
    render: (_, stock) => {
      return <StockAlertEmailListColumn emailList={stock.email_list} />
    }
  },
  // Mobile
  {
    title: () => <CustomHeaderText text={'StockAlert.Title'} />,
    responsive: ['xs'],
    sorter: (a: StockAlert, b: StockAlert) => {
      return a.project.name.length - b.project.name.length
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
      return (
        <FormLabels
          title={`${record.project.name} ${record.threshold} %`}
          subtitle={record.email_list.join(',')}
        />
      )
    }
  },
  {
    title: () => <CustomHeaderText text='Deposits.Actions' />,
    responsive: ['sm', 'xs'],
    dataIndex: 'project',
    render: (_, stock) => {
      return <StockAlertActionsColumn stockAlertId={stock.id} />
    }
  },

]

export default stockAlertListColumns
